// src/customer/customer-policy/customer-policy-commission/commissionFormatters.ts

// Adds the % and one decimal so 20 reads "20.0%" like the mockup, and null stays empty instead of "null%"
export const rateOrEmpty = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return "";
  return `${value.toLocaleString("en-US", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 2,
  })}%`;
};
